module.exports = __webpack_public_path__ + "img/card-services-month-certification-hover.31d3d26d.svg";